import React, { useEffect, useRef, useState } from 'react';

import styles from './selectGlobal.module.css';
import { SearchInputV2 } from '../SearchInputV2';
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers';
import { LoadingSpan } from '../Loadings/loadingSpan';

const resolveImageSrc = (src?: string | null) => {
    if (!src) return ''
    if (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('data:')) {
        return src
    }
    return toAbsoluteUrl(src)
}

const resolveItemImage = (item?: any, fallback?: string | null) =>
    item?.link_imagem || item?.linkIcon || item?.image_url || fallback || null

const resolveSvgColorClass = (iconColor?: string | null) =>
    iconColor ? `svg-icon-${iconColor}` : 'svg-icon-muted'

const isSvgPath = (src?: string | null) => !!src && src.endsWith('.svg')

type Props = {
    itens: any[] | undefined;
    buttonAll: boolean;
    value: string | number;
    textSearch?: string | null;
    textButtonInit?: string | null;
    typeIcon?: "img" | "svg" | "icon" | "badge" | "tag";
    linkIcon?: string;
    sizeIconSvg?: string;

    badgeColor?: string; 
    badgeText?: string; 
    badgeKey?: string;  
    colorsBadge?: Record<string, string>; 
    imageSize?: string;
    colorKey?: string;

    onChange: (value: string) => void;
    labelKey: string;
    valueKey: string;
    className?: any;
    setPagination?: any;
    loading?: boolean;
    style?: any
}

export function SelectGlobal({
    itens, 
    buttonAll,  
    value,
    textSearch,
    textButtonInit,
    onChange,
    labelKey,
    valueKey,
    className,
    typeIcon,
    linkIcon,
    sizeIconSvg,
    setPagination,
    loading,
    badgeColor,
    badgeText,
    badgeKey,
    colorsBadge,
    style,
    imageSize,
    colorKey = 'color',
}: Props) {
    const [filterLabel, setFilterLabel] = useState<{
        linkIcon?: string | null,
        value: string | number,
        label: string,
        badgeColor?: string | null,
        badgeText?: string,
        tagColor?: string | null,
        iconColor?: string | null,
      } | null>(() => {
        if (itens && itens.length > 0 && value !== "") {
          const selectedItem = itens.find((item: any) => item[valueKey] === value);
      
          if (selectedItem) {
            const badgeTextFromItem = badgeKey ? selectedItem[badgeKey] : "";
            const badgeColorFromItem =
              colorsBadge && badgeTextFromItem
                ? colorsBadge[badgeTextFromItem] || "primary"
                : badgeColor || null;
      
            return {
              linkIcon: resolveItemImage(selectedItem),
              value: selectedItem[valueKey],
              label: selectedItem[labelKey] || "",
              badgeColor: badgeColorFromItem,
              badgeText: badgeTextFromItem,
              tagColor: selectedItem[colorKey] || null,
              iconColor: selectedItem.iconColor || null,
            };
          }
        }
      
        return {
          linkIcon: null,
          value: value,
          label: "",
          badgeColor: badgeColor ? badgeColor : null,
          badgeText: badgeText ? badgeText : "",
          tagColor: null,
          iconColor: null,
        };
      });

    const [mySearch, setMySearch] = useState<any[]>([]);
    const [control, setControl] = useState<boolean>(false);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    function handleChange(filterLabel: any, myOnChange: any) {
        const emptyFilterLabel = {
            linkIcon: null,
            value: "",
            label: "",
            badgeColor: badgeColor ? badgeColor : null,
            badgeText: badgeText ? badgeText : "",
            tagColor: null,
            iconColor: null,
        };

        setFilterLabel(filterLabel === null ? emptyFilterLabel : filterLabel);
        onChange(myOnChange);
        setIsOpen(false);

        if(setPagination !== undefined){
            setPagination((prev) => ({
                ...prev,
                page: 1
            })); 
        }
    }

    useEffect(() => {
        if (!isOpen) return;

        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isOpen]);

    useEffect(() => {
        if (value === "" || value === undefined || value === null) {
            setFilterLabel({
                linkIcon: null,
                value: "",
                label: "",
                badgeColor: badgeColor ? badgeColor : null,
                badgeText: badgeText ? badgeText : "",
                tagColor: null,
                iconColor: null,
            });
            return;
        }

        if (itens && itens.length > 0) {
          const selectedItem = itens.find((item: any) => item[valueKey] === value);
      
          if (selectedItem) {
            const badgeTextFromItem = badgeKey ? selectedItem[badgeKey] : "";
            const badgeColorFromItem =
              colorsBadge && badgeTextFromItem
                ? colorsBadge[badgeTextFromItem] || "primary"
                : badgeColor || null;
      
            setFilterLabel({
              linkIcon: resolveItemImage(selectedItem),
              value: selectedItem[valueKey],
              label: selectedItem[labelKey] || "",
              badgeColor: badgeColorFromItem,
              badgeText: badgeTextFromItem,
              tagColor: selectedItem[colorKey] || null,
              iconColor: selectedItem.iconColor || null,
            });
          }
        }
      }, [value, itens, badgeKey, colorsBadge, badgeColor, badgeText, labelKey, valueKey, colorKey]);

    const renderTagBadge = (label: string, color?: string | null, compact = false) => (
        <span
            className={`badge ${styles.tagBadgeSelect}`}
            style={{
                backgroundColor: color || '#3498DB',
                color: '#fff',
                fontSize: compact ? '0.75rem' : '0.8rem',
                padding: compact ? '0.35rem 0.65rem' : '0.4rem 0.75rem',
            }}
        >
            {label || 'Tag'}
        </span>
    )

    return (
        <div className={className ? className : ''} style={style ? style : {}}>
            <div
                ref={dropdownRef}
                className={`me-0 dropdown ${styles.divGlobalSelect}`}
                style={{ position: 'relative' }}
            >
                <button
                    className={`btn btn-lg btn-light ${styles.buttonMainSelect} ${
                        filterLabel && filterLabel.value !== "" && filterLabel.value !== undefined && filterLabel.value !== null
                            ? styles.buttonMainSelectSelected
                            : ""
                    }`}
                    type="button"
                    aria-expanded={isOpen}
                    onClick={(event) => {
                        event.preventDefault()
                        event.stopPropagation()
                        setIsOpen((prev) => !prev)
                    }}
                >
                    <span className={styles.spanButtonMainSelectV2}>
                        {
                            typeIcon === "icon" ?
                                <i className={`${linkIcon ? linkIcon : ""} fs-5`}></i>
                            : typeIcon === "img" ?
                                filterLabel && filterLabel.linkIcon ?
                                    isSvgPath(filterLabel.linkIcon) ?
                                        <KTSVG
                                            path={filterLabel.linkIcon}
                                            className={`${resolveSvgColorClass(filterLabel.iconColor)} svg-icon-${sizeIconSvg ? sizeIconSvg : "3x"} ms-n1`}
                                        />
                                    :
                                        <div className={`symbol symbol-${imageSize ? imageSize : "25px"} ${styles.divImgButtonSelect}`}>
                                            <img 
                                                src={resolveImageSrc(
                                                    filterLabel?.linkIcon || linkIcon || ''
                                                )} 
                                                className='' 
                                                alt='' 
                                            />
                                        </div>
                                :
                                    linkIcon ?
                                        linkIcon.endsWith('.svg') ?
                                            <KTSVG 
                                                path={linkIcon} 
                                                className={`svg-icon-muted svg-icon-${sizeIconSvg ? sizeIconSvg : "3x"} ms-n1`} 
                                            />
                                        :
                                            <div className={`symbol symbol-${imageSize ? imageSize : "20px"} ${styles.divImgButtonSelect}`}>
                                                <img 
                                                    src={resolveImageSrc(linkIcon)} 
                                                    className='' 
                                                    alt='' 
                                                />
                                            </div>
                                    :
                                        <></>
                            : typeIcon === "svg" ?
                                <KTSVG 
                                    path={filterLabel?.linkIcon ? filterLabel.linkIcon : linkIcon ? linkIcon : ""} 
                                    className={`${resolveSvgColorClass(filterLabel?.iconColor)} svg-icon-${sizeIconSvg ? sizeIconSvg : "3x"} ms-n1`} 
                                />
                            : typeIcon === "badge" && filterLabel && filterLabel.badgeColor ?
                                <span 
                                    className={`badge badge-${filterLabel.badgeColor} fs-9`}
                                    style={{height: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                                >
                                    {filterLabel.badgeText ? filterLabel.badgeText : ''}
                                </span>
                            :
                            <></> 
                        }
                        {typeIcon === "tag" ? (
                            filterLabel && filterLabel.label !== "" ? (
                                renderTagBadge(filterLabel.label, filterLabel.tagColor)
                            ) : (
                                <>
                                    {linkIcon && (
                                        <KTSVG
                                            path={linkIcon}
                                            className={`svg-icon-muted svg-icon-${sizeIconSvg ? sizeIconSvg : "3x"} ms-n1`}
                                        />
                                    )}
                                    <span className={`${styles.spanButtonMainSelect}`}>
                                        {textButtonInit ? textButtonInit : "Selecione uma opção"}
                                    </span>
                                </>
                            )
                        ) : (
                            <span className={`${styles.spanButtonMainSelect}`}>
                                {filterLabel && filterLabel.label !== "" ? filterLabel.label : textButtonInit ? textButtonInit : "Selecione uma opção"} 
                            </span>
                        )}
                    </span>
                    {
                        loading && loading === true ?
                            <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                        :
                            <i className="bi bi-caret-down-fill fs-7"></i>
                    }

                </button>

                <div 
                    className={`dropdown-menu dropdown-menu-end border border-1 border-light ${styles.divOptionsSelectV1} ${className ? className : ''} ${isOpen ? 'show' : ''}`} 
                    style={{
                        position: 'absolute',
                        zIndex: 1050,
                    }}
                    onClick={(event) => event.stopPropagation()}
                >
                    <div className={`card-toolbar nav nav-tabs ${styles.divOptionsSelectV2}`} data-kt-buttons='true'>
                        <div className={styles.divSearchSelect}>
                            <SearchInputV2
                                className='form-control form-control-sm bg-light'
                                placeholder={textSearch ? textSearch : "Buscar"}
                                myDate={itens}
                                setMySearch={setMySearch}
                                control={control}
                                style={{ width: '100%' }}
                                setControl={setControl}
                                searchParameter={labelKey}
                                disabled={loading ? loading : false}
                            />
                        </div>
                        <div className={styles.divOptionsSelectV3}>
                            {buttonAll && (
                                <button
                                    type="button"
                                    className={`btn btn-sm btn-color-muted btn-active btn-active-primary bg-hover-light ${filterLabel && filterLabel.value === "" ? "active" : "text-hover-primary"} px-5 ${styles.buttonAllSelect}`}
                                    data-bs-toggle="tab"
                                    disabled={loading ? loading : false}
                                    onClick={(event) => {
                                        event.preventDefault()
                                        handleChange(null, "")
                                    }}
                                >
                                    <span style={{ textAlign: 'start' }}>
                                        Todos
                                    </span>
                                </button>
                            )}
                            
                            {loading ?
                                <div style={{width: '100%', display: 'flex', justifyContent: 'center', marginTop: '1rem', marginBottom: '1rem'}}>
                                    <LoadingSpan style={{marginLeft: '0.5rem'}}/>
                                </div>
                            :
                            (control ? mySearch : itens)?.map((item: any) => {
                                const badgeTextFromItem = badgeKey ? item[badgeKey] : "";
                                const badgeColorFromItem = colorsBadge && badgeTextFromItem
                                    ? colorsBadge[badgeTextFromItem] || "primary"
                                    : "primary";
                                const tagColorFromItem = item[colorKey] || null;
                                const itemIcon = resolveItemImage(item, linkIcon) || '';
                                const itemIconColor = item.iconColor || null;
                            
                                return (
                                    <button
                                        type="button"
                                        key={item[valueKey]}
                                        className={`btn btn-sm btn-color-muted btn-active btn-active-primary bg-hover-light ${styles.buttonAllSelect} ${filterLabel && filterLabel.value === item[valueKey] ? "active" : "text-hover-primary"} px-5`}
                                        data-bs-toggle="tab"
                                        onClick={(event) => {
                                            event.preventDefault()
                                            handleChange(
                                                { 
                                                    linkIcon: itemIcon, 
                                                    value: item[valueKey], 
                                                    label: item[labelKey] || "",
                                                    badgeColor: badgeColorFromItem,
                                                    badgeText: badgeTextFromItem,
                                                    tagColor: tagColorFromItem,
                                                    iconColor: itemIconColor,
                                                }, 
                                                item[valueKey]
                                            )
                                        }}
                                    >
                                        {typeIcon === "img" ? (
                                            isSvgPath(itemIcon) ? (
                                                <KTSVG
                                                    path={itemIcon}
                                                    className={`${resolveSvgColorClass(itemIconColor)} svg-icon-${sizeIconSvg ? sizeIconSvg : "3x"} ms-n1`}
                                                />
                                            ) : (
                                                <div className={`symbol symbol-${imageSize ? imageSize : "20px"} ${styles.divImgButtonSelect}`}>
                                                    <img 
                                                        src={resolveImageSrc(itemIcon)} 
                                                        alt='' 
                                                    />
                                                </div>
                                            )
                                        ) : typeIcon === "svg" ? (
                                            <KTSVG 
                                                path={item.linkIcon ? item.linkIcon : linkIcon ? linkIcon : ""} 
                                                className={`${resolveSvgColorClass(itemIconColor)} svg-icon-${sizeIconSvg ? sizeIconSvg : "3x"} ms-n1`} 
                                            />
                                        ) : typeIcon === "icon" ? (
                                            <i className={`${linkIcon ? linkIcon : ""} fs-5`}></i>
                                        ) : typeIcon === "tag" ? (
                                            renderTagBadge(item[labelKey] || 'Tag', tagColorFromItem, true)
                                        ) : <></>}
                                        
                                        {typeIcon !== "tag" && (
                                            <span className={styles.spanButtonSelectedSelect}>
                                                {item[labelKey] || "Não identificado"}
                                            </span>
                                        )}

                                        {
                                            typeIcon === "badge" && (
                                                <span 
                                                    className={`badge badge-${badgeColorFromItem} fs-9`}
                                                    style={{height: '1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
                                                >
                                                    {badgeTextFromItem}
                                                </span>
                                            ) 
                                        }
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
